import classNames from "classnames"
import React from "react"

import { Color } from "../../../constants/V2/color"
import GatsbyStoryblokImage from "../../elements/V2/GatsbyStoryblokImage"
import Typography from "../../elements/V2/Typography"
import LayoutItem from "../Layouts/LayoutItem"

import { getAccentColor, getBackgroundColorClass } from "@utils/V2/color"

type SocialProofProps = {
  backgroundColor: Color
  title: string
  primaryImageUrl: string
  body?: string
  secondaryImageUrl?: string
  overrideTextColor?: Color
  mobileGridOrder?: number
}

const SocialProof = ({
  backgroundColor,
  overrideTextColor,
  title,
  body,
  primaryImageUrl,
  secondaryImageUrl,
  mobileGridOrder,
}: SocialProofProps) => {
  return (
    <LayoutItem
      className={classNames(
        "col-span-full grid grid-cols-subgrid rounded-20",
        !secondaryImageUrl && getBackgroundColorClass(backgroundColor)
      )}
      mobileGridOrder={mobileGridOrder}
    >
      <div
        className={classNames(
          "col-span-full row-span-1 my-auto rounded-20 px-24 py-20 md:col-span-3 md:py-32 lg:col-span-6 lg:px-32"
        )}
      >
        <Typography
          font="grotesk"
          weight="medium"
          size="lead-lg"
          color={
            overrideTextColor
              ? overrideTextColor
              : getAccentColor(backgroundColor)
          }
          text={title}
        />
        {body && (
          <Typography
            font="grotesk"
            weight="book"
            size="body-lg"
            color={
              overrideTextColor
                ? overrideTextColor
                : getAccentColor(backgroundColor)
            }
            text={body}
          />
        )}
      </div>
      <div
        className={classNames(
          secondaryImageUrl && getBackgroundColorClass(backgroundColor),
          {
            "col-span-full md:col-span-3 lg:col-span-6": !secondaryImageUrl,
          },
          {
            "col-span-full row-start-2 grid grid-cols-subgrid rounded-20":
              secondaryImageUrl,
          }
        )}
      >
        <div
          className={classNames(
            "px-24 py-20 md:py-32 lg:px-32",
            {
              "col-span-full": !secondaryImageUrl,
            },
            {
              "col-span-full col-start-1 md:col-end-4 lg:col-end-7":
                secondaryImageUrl,
            }
          )}
        >
          <GatsbyStoryblokImage
            loadType="eager"
            image={primaryImageUrl}
            alt="Marquee banner icon"
            aspectRatio="fullWidth"
            className="w-full"
          />
        </div>
        {secondaryImageUrl && (
          <div className="col-span-full px-24 py-20 md:col-start-4 md:py-32 lg:col-start-7 lg:row-start-1 lg:px-32">
            <GatsbyStoryblokImage
              loadType="eager"
              image={secondaryImageUrl}
              alt="Marquee banner icon"
              aspectRatio="fullWidth"
              className="w-full"
            />
          </div>
        )}
      </div>
    </LayoutItem>
  )
}

export default SocialProof
